import numberFormatter from 'currency-formatter'

export const getString = ({ 
  message, fall_message = 'Ocorreu um erro'
})  => {
  // PREVINE DE DAR UM LOG NA TELA (TOAST NOTIFICATION | ALERT ...) DE UM VALOR QUE NÃO É STRING

  if (!message) {
    message = fall_message
  }

  return typeof message === 'string' ? message : typeof fall_message === 'string' ? fall_message : 'Ocorreu um erro'
}

export const submit_state = {
  done: false, // SE A REQUISICAO JÁ ACABOU
  req: false, // SE A FUNCAO DE REQUISIAO ESTÁ EM ANDAMENTO
  status: false // SE A REQUISICAO DEU SUCESSO OU ERRO
}

export const dateFormated = () => {

  const _d = new Date()

  const get = lang => _d.toLocaleString(lang, { weekday: 'long', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric' })
  
  return {
    pt: get('pt'),
    us: get('en')
  }
}

export const getPrice = (v) => {

  // return numberFormatter.format(+v, {
  //   code: 'BRL',
  //   locale: 'pt-BR'
  // })

  return (v || 0).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency'})

}

export const capitalize = v => v[0].toUpperCase() + v.substring(1)

export const getStatus = ({ status, lang = 'pt', manutencao }) => {
  switch (status) {
    case 1:
      return lang === 'pt' ? manutencao ? 'Concluído' : 'Entregue' : manutencao ? 'Concluded' : 'Delivered'
    case 2:
      return lang === 'pt' ? 'Processando' : 'Processing'
    case 3:
      return lang === 'pt' ? 'Aguardando' : 'Waiting'
    case 0:
      return lang === 'pt' ? 'Cancelado' : 'Canceled'
    default:
      return ''
  }
}

export const getQuery = query => Object.entries(query).filter(([_, value]) => String(value).length).map(([ key, value ]) => `${ key }=${ encodeURIComponent(value) }`).join('&')

// CONVERTE O HORARIO PARA MINUTOS DESDE A MEIA NOITE
// ACEITA 'HH:MM' (FORMATO ATUAL) E NUMERO (FORMATO LEGADO / HORARIO DE FUNCIONAMENTO)
const toMinutes = v => {
  if (v === undefined || v === null || v === '') return null

  if (typeof v === 'number') return v * 60

  const [ hours, minutes ] = String(v).split(':')

  return (+hours) * 60 + (+minutes || 0)
}

const DIAS_PT = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
const DIAS_US = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

// '' = TODOS OS DIAS (NAO HÁ RESTRICAO A EXIBIR)
const getDiasString = (lang, dias) => {
  if (!Array.isArray(dias) || !dias.length || dias.length === 7) return ''

  const nomes = lang === 'us' ? DIAS_US : DIAS_PT

  const ordenados = [ ...dias ].sort((a, b) => a - b)

  const consecutivos = ordenados.every((dia, i) => i === 0 || dia === ordenados[i - 1] + 1)

  if (consecutivos && ordenados.length > 2) {
    const primeiro = nomes[ordenados[0]], ultimo = nomes[ordenados[ordenados.length - 1]]

    return lang === 'us' ? `${ primeiro } to ${ ultimo }` : `${ primeiro } a ${ ultimo }`
  }

  return ordenados.map(dia => nomes[dia]).join(', ')
}

// pt: 18 -> '18h' | '18:30' -> '18h30'    us: 18 -> '6pm' | '18:30' -> '6:30pm'
const getHoraString = (lang, v) => {
  const total = toMinutes(v)

  if (total === null) return ''

  const hours = Math.floor(total / 60) % 24, minutes = total % 60

  if (lang === 'us') {
    const sufixo = hours >= 12 ? 'pm' : 'am'

    const _hours = hours % 12 === 0 ? 12 : hours % 12

    return minutes
      ? `${ _hours }:${ String(minutes).padStart(2, '0') }${ sufixo }`
      : `${ _hours }${ sufixo }`
  }

  return minutes ? `${ hours }h${ String(minutes).padStart(2, '0') }` : `${ hours }h`
}

// TEM ALGUMA RESTRICAO DE DISPONIBILIDADE? (JANELA DE HORARIO OU DIAS DA SEMANA)
// AUSENCIA DE VALOR / JANELA VAZIA / TODOS OS DIAS = SEM RESTRICAO = SEMPRE DISPONIVEL
export const hasTimeRestriction = (time) => {
  if (!time) return false

  const { startTime, endTime, dias } = time

  const _start = toMinutes(startTime), _end = toMinutes(endTime)

  const semJanela = _start === null || _end === null || _start === _end

  const semRestricaoDeDia = !Array.isArray(dias) || !dias.length || dias.length === 7

  return !(semJanela && semRestricaoDeDia)
}

// DESCREVE A RESTRICAO DE DISPONIBILIDADE (NAO O ESTADO ATUAL - ISSO É isAvailableTime)
// RETORNA '' QUANDO NAO HÁ RESTRICAO NENHUMA, PARA O CARD NAO EXIBIR FAIXA
export const getTimeString = (lang, { start, end, dias }) => {
  // SEM RESTRICAO = SEMPRE DISPONIVEL, NAO HÁ O QUE INFORMAR
  if (!hasTimeRestriction({ startTime: start, endTime: end, dias })) return ''

  const _start = toMinutes(start), _end = toMinutes(end)

  const semJanela = _start === null || _end === null || _start === _end

  const diasString = getDiasString(lang, dias)

  if (semJanela) {
    return lang === 'us' ? `Available ${ diasString }` : `Disponível ${ diasString }`
  }

  const janela = lang === 'us'
    ? `from ${ getHoraString(lang, start) } to ${ getHoraString(lang, end) }`
    : `das ${ getHoraString(lang, start) } às ${ getHoraString(lang, end) }`

  const prefixo = lang === 'us' ? 'Available' : 'Disponível'

  return diasString
    ? `${ prefixo } ${ diasString }, ${ janela }`
    : `${ prefixo } ${ janela }`
}

// AUSENCIA DE VALOR = SEMPRE DISPONIVEL
export const isAvailableTime = (start, end, dias) => {
  const now = new Date()

  if (Array.isArray(dias) && dias.length && !dias.includes(now.getDay())) return false

  const _start = toMinutes(start), _end = toMinutes(end)

  if (_start === null || _end === null || _start === _end) return true

  const current = now.getHours() * 60 + now.getMinutes()

  const endAtNextDay = _start > _end

  if (endAtNextDay) {
    return current >= _start || current < _end
  } else {
    return current >= _start && current < _end
  }
}
